module.exports = "/images/hn.svg?054a8ca9fd00077a1a5c267249836292";